import React, { Component } from 'react'
import Auth from '../auth/Auth'

class Home extends Component {
  login() {
    Auth.login()
  }
  logout() {
    Auth.logout()
  }
  render() {
    return (
      <div className="container">
        {Auth.isAuthenticated() && (
          <div>
            <h4>You are logged in!</h4>
            <a style={{ cursor: 'pointer' }} onClick={this.logout.bind(this)}>
              Log out
            </a>
          </div>
        )}
        {!Auth.isAuthenticated() && (
          <h4>
            You are not logged in! Please{' '}
            <a style={{ cursor: 'pointer' }} onClick={this.login.bind(this)}>
              Log In
            </a>{' '}
            to continue.
          </h4>
        )}
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js